import React from "react";
import successBg from "/images/hero.jpeg";
import pdfFile from "/brochure.pdf";


const Success = () => {
  return (
    <>
      <section
        className="bg-cover h-screen flex justify-center"
        style={{
          backgroundImage: `url(${successBg})`,
          backgroundColor: "rgba(0, 0, 0, 0.4)",
          backgroundBlendMode: "darken",
        }}
        id="home"
      >
        <div className="text-center backdrop-blur-md md:p-10 p-5 h-max my-auto rounded-md md:max-w-[550px] max-w-[300px]">
          <h2 className="text-white font-medium md:text-[40px] text-[20px] mb-2">
            Congratulations!
          </h2>
          <p className="text-white md:text-[20px] text-[16px]">
            Registration successful. Kindly check your email for further
            instructions. Our counsellor will reach out shortly.
          </p>

          <div className="flex gap-3 align-center justify-center mt-8">
          <div className="bg-navy rounded-lg pb-2 pr-2">  
          <a href={pdfFile} download={'Brochure'} className="flex items-center relative z-1 bg-[#EDA12E] text-white text-navy md:text-xl text-lg font-bold py-3 md:px-6 px-4 md:mx-0 mx-2 rounded-lg shadow-xl">
            Download Brochure
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 ml-2 ">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 13.5 12 21m0 0-7.5-7.5M12 21V3" />
                </svg>
        </a>
          </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Success;
